module.exports = __webpack_public_path__ + "static/index-acfca6a9a34022ac0cbc8460763ec6ad.png";